/**
 * @generated SignedSource<<acad83623e3a1bfdd23b1e32a1ce933a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelProductsOnDefaultQuery$variables = Record<PropertyKey, never>;
export type salesChannelProductsOnDefaultQuery$data = {
  readonly productsOnDefaultSalesChannel: ReadonlyArray<{
    readonly code: string;
    readonly id: string;
    readonly name: string;
  }>;
};
export type salesChannelProductsOnDefaultQuery = {
  response: salesChannelProductsOnDefaultQuery$data;
  variables: salesChannelProductsOnDefaultQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductBySalesChannel",
    "kind": "LinkedField",
    "name": "productsOnDefaultSalesChannel",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelProductsOnDefaultQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelProductsOnDefaultQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "12973329525cf54f05fa5e0cc6436752",
    "id": null,
    "metadata": {},
    "name": "salesChannelProductsOnDefaultQuery",
    "operationKind": "query",
    "text": "query salesChannelProductsOnDefaultQuery {\n  productsOnDefaultSalesChannel {\n    id\n    code\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "18564337ab3c892a83e79fe4f028f6ff";

export default node;
